.brk {
    display: none;
    flex-basis: 100%;
    height: var(--space-medium);
}

@media screen and (width <=800px) {
    .brk {
        display: block;
    }
}